module.exports = __webpack_public_path__ + "static/media/linkedin-icon.e48f25d9.svg";